import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './TeacherLogin.css';

const TeacherLogin = ({ onLogin }) => {
  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Check teachers created by admin
    const teachers = JSON.parse(localStorage.getItem('teachers') || '[]');
    const teacher = teachers.find(t => t.email === credentials.email && t.password === credentials.password);

    if (teacher) {
      const userData = {
        ...teacher,
        role: 'teacher'
      };
      onLogin(userData);
      navigate('/teacher-dashboard');
    } else {
      setError('Invalid teacher credentials or teacher not registered by admin');
    }
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    setError('');
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <Link to="/" className="back-button">← Back</Link>
        
        <div className="login-header">
          <h2>Teacher Portal</h2>
          <p>Sign in to manage your courses</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={credentials.email}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter your email"
              required
            />
          </div>

          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={credentials.password}
              onChange={handleChange}
              className="form-input"
              placeholder="Enter your password"
              required
            />
          </div>

          <button type="submit" className="login-btn">
            Sign In
          </button>
        </form>

        <div className="demo-credentials">
          <h4>Teacher Login:</h4>
          <p>Use credentials provided by admin</p>
        </div>
      </div>
    </div>
  );
};

export default TeacherLogin;